import { Flex, Box, Text, Skeleton, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import useApiQuery from 'lib/api/useApiQuery';
import { nbsp } from 'lib/html-entities';
import { HOMEPAGE_STATS } from 'stubs/stats';
import Pagination from 'ui/shared/pagination/Pagination';
import type { PaginationParams } from 'ui/shared/pagination/types';

interface Props {
  pagination: PaginationParams;
}

const BlocksTabSlot = ({ pagination }: Props) => {
  const statsQuery = useApiQuery('homepage_stats', {
    queryOptions: {
      placeholderData: HOMEPAGE_STATS,
    },
  });

  return (
    <Flex
      alignItems="center"
      columnGap={8}
      display={{ base: 'none', lg: 'flex' }}
    >
      <Pagination my={1} {...pagination} />
    </Flex>
  );
};

export default BlocksTabSlot;
